var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useAppSelector } from '../../../../store';
import { participantsSelector } from '../../../../store/slices/participantSlice';
const RaiseHandIcon = ({ userId }) => {
    _react_refresh_temp_2();
    const participant = useAppSelector((state) => participantsSelector.selectById(state, userId));
    const render = useMemo(() => {
        if (participant === null || participant === void 0 ? void 0 : participant.metadata.raised_hand) {
            return (_jsx("div", { className: "hand ltr:mr-2 rtl:ml-2 cursor-pointer", children: _jsx("i", { className: "pnm-raise-hand text-[#ffbd40] text-[10px]" }) }));
        }
        else {
            return null;
        }
    }, [participant === null || participant === void 0 ? void 0 : participant.metadata.raised_hand]);
    return _jsx(_Fragment, { children: render });
};
_react_refresh_temp_1 = RaiseHandIcon;
$RefreshReg$(_react_refresh_temp_1, "RaiseHandIcon");
_react_refresh_temp_2(RaiseHandIcon, "mFor7mPvO6NzrWd/wtuReDr2lkg=", false, () => [useAppSelector]);
export default RaiseHandIcon;
